/*
 * Megamenu
 */

/* global biro_vw_mobile */
/* global biro_body */


// On page load
jQuery(function($) {


	// Init
	var hmw = $( '.header-menu-wrapper' );


	// Desktop megamenu
	$('.nav-dynamic')
		.on(
			'mouseenter focus',
			'.menu-level-0.menu-item-has-children > .menu-item-link',
			function(e) {
				if (!biro_vw_mobile) {
					var el = $(this);
					el.toggleClass('has-focus');
					//console.log( 'focus top level link: ' + el.text() );
					// Show sub-menu
					el.parents('.menu-item').attr('aria-expanded', 'true');
				}
			}
		)
		.on(
			'mouseleave blur',
			'.menu-level-0.menu-item-has-children > .menu-item-link',
			function(e) {
				if (!biro_vw_mobile) {
					var el = $(this);
					el.toggleClass('has-focus');
					//console.log( 'blur top level link: ' + el.text() );
					// Only hide sub-menu after a short delay, so links get a chance to catch focus from tabbing
					setTimeout(function() {
						var smw = el.siblings('.sub-menu-wrapper');
						if (smw.attr('data-has-focus') !== 'true') {
							el.parents('.menu-item').attr('aria-expanded', 'false');
						}
					}, 100);
				}
			}
		)
		.on('mouseenter focusin', '.sub-menu-wrapper', function(e) {
			if (!biro_vw_mobile) {
				var el = $(this);
				//console.log( 'focus sub-menu-wrapper' );
				el.attr('data-has-focus', 'true');
			}
		})
		.on('mouseleave blur', '.sub-menu-wrapper', function(e) {
			if (!biro_vw_mobile) {
				var el = $(this);
				setTimeout(function() {
					// Check if anything else has picked up focus (i.e. next link in sub-menu)
					if (el.find(':focus').length === 0) {
						//console.log( 'blur sub-menu link: ' + el.text() );
						el.attr('data-has-focus', 'false');
						// Hide sub-menu on the way out if parent link doesn't have focus
						if (el.siblings('.menu-item-link.has-focus').length === 0) {
							el.parents('.menu-level-0').attr('aria-expanded', 'false');
						}
					}
				}, 100);
			}
		})
		.on('click', '.sub-menu-control', function(e) {
			// Handle sub-menu control for mobile
			if (biro_vw_mobile) {
				var el = $(this);
				var p = el.parents('[aria-expanded]');
				el.toggleClass('sub-menu-control-open');
				p.attr(
					'aria-expanded',
					p.attr('aria-expanded') == 'true' ? 'false' : 'true'
				);
			}
		});


	// Mobile toggle
	biro_body.on( 'click', '.mobile-menu-toggle', function() {

		var el = $( this );

		if ( el.attr( 'aria-expanded' ) === 'false' ) {

			hmw.removeClass( 'mobile-menu-closed' ).slideDown( 300 );
			el.attr( 'aria-expanded', 'true' );

		} else {

			hmw.slideUp( 300, function() {
				hmw.addClass( 'mobile-menu-closed' );
			});
			el.attr( 'aria-expanded', 'false' ).blur();
		}
	});


});
